export default "/kiban/_next/static/images/29_8L_3-2-3_withBH_fullstack-10f59a37ef242829bd51944fb4e2f7b1.png";